module.exports = __webpack_public_path__ + "static/media/IMG_3484_sm.ee54e46c.jpg";